import React from 'react'
import PropType from 'prop-types'
import CopyOnly from './copy-only'
import Interactive from './interactive'

const RichCta = ({ url, formUrl, variation, theme, utms, title, body, ctaText, form, nmls }) => {
  const queryString = Object.keys(utms).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(utms[k])}`).join('&'),
    href = `${url}?${queryString}`,
    formHref = `${formUrl}?${queryString}`

  switch (variation) {
    case 'copy-only':
      return <CopyOnly href={href} theme={theme} title={title} body={body} ctaText={ctaText} nmls={nmls} />
    case 'interactive':
      return (
        <Interactive
          href={formHref}
          theme={theme}
          title={title}
          body={body}
          ctaText={ctaText}
          Form={form}
          queryString={queryString}
        />
      )
    default:
      return null
  }
}

RichCta.propTypes = {
  url: PropType.string.isRequired,
  formUrl: PropType.string,
  variation: PropType.string.isRequired,
  form: PropType.func,
  utms: PropType.object.isRequired,
  title: PropType.string.isRequired,
  theme: PropType.string.isRequired,
  body: PropType.string.isRequired,
  ctaText: PropType.string.isRequired,
  nmls: PropType.bool,
}

RichCta.defaultProps = {
  nmls: false,
}

export { RichCta }

export default RichCta
